<div class="astral-auth-shell">
  <main class="astral-auth-panel astral-auth-panel--wide">
    <header class="astral-auth-header">
      <div class="astral-auth-branding">
        <img src="assets/icons/hogia_logo.svg" alt="Hogia" />
        <span class="astral-auth-branding__divider" aria-hidden="true"></span>
        <span class="astral-auth-branding__name">DinHyresvärd</span>
      </div>
      <app-language class="astral-auth-language" [orientation]="2"></app-language>
    </header>

    <section class="astral-auth-content">
      @if (form && !completed) {
        <astral-form
          class="astral-auth-form"
          [form]="form"
          [columns]="2"
          [tabletColumns]="2"
          [mobileColumns]="1"
          autocomplete="on"
          (formSubmit)="onSubmit()"
        >
          <h1 class="astral-auth-title astral-auth-form__full">{{ 'CREATE_DEMO_HEADER' | translate }}</h1>

          <astral-input [control]="form.controls['name']" inputName="company-name"></astral-input>
          <astral-input [control]="form.controls['referenceName']" inputName="reference-name"></astral-input>
          <app-org-number [control]="form.controls['organizationNo']"></app-org-number>
          <astral-input
            [control]="form.controls['email']"
            type="email"
            inputName="email"
            inputMode="email"
            autocomplete="email"
          ></astral-input>
          <astral-input
            [control]="form.controls['phone']"
            type="phone"
            inputName="phone"
            inputMode="tel"
            autocomplete="tel"
          ></astral-input>

          <div class="astral-auth-form__full">
            <app-postal-address
              [group]="form.controls['address']"
              [model]="dataContext.address"
              [title]="null"
              [mandatory]="true"
            ></app-postal-address>
          </div>

          <div class="astral-auth-form__full astral-form-actions astral-form-actions--start">
            <astral-button
              type="submit"
              variant="primary"
              [disabled]="workInProgress"
              labelKey="SAVE_BTN_REGISTER"
            ></astral-button>
            @if (workInProgress) {
              <span class="astral-auth-progress" role="status" aria-live="polite">
                <span class="throbber" aria-hidden="true"></span>
              </span>
            }
          </div>
        </astral-form>
      } @else if (completed) {
        <section class="astral-auth-notice" aria-live="polite">
          <h1 class="astral-auth-title">{{ 'CREATE_DEMO_COMPLETE_HEADER' | translate }}</h1>
          <p>{{ 'CREATE_DEMO_COMPLETE_MESSAGE' | translate }}</p>
        </section>
      }
    </section>
  </main>
</div>
